/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ICreateMasqBoxArgs } from "./components";

const is = require("is_js");

const SERVICE_NAME = "CreateMasqBoxPageService";
const log: any = LoggerModule.getInstance();

export class CreateMasqBoxPageService {
  private static instance: CreateMasqBoxPageService;
  private vapp: VApplication;
  private selectedCostume: any;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CreateMasqBoxPageService {
    if (!CreateMasqBoxPageService.instance) {
      CreateMasqBoxPageService.instance = new CreateMasqBoxPageService(props);
    }
    return CreateMasqBoxPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public setSelectedCostume(data: any) {
    this.selectedCostume = data;
  }

  public getSelectedCostume() {
    return this.selectedCostume;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public async getCities() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getCities();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log("content96====", content);
    return content;
  }

  public async updateMailAddress(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.updateBox(arg);
    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    // compProps = await agent.getDiscountPresentationListsProps();
    compProps = await agent.getPresentationListsProps();
    content = { ...content, ...compProps };

    compProps = await agent.getMasqueraderListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentation() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getAdminPresentationListsProps();
    return content;
  }

  public async getDiscountPresentation() {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getDiscountPresentationListsProps();
    return content;
  }

  public async getCostumeType(costumeId: string) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getCostumeType(costumeId);

    return content;
  }

  public async sendPurchaseInvite(args: any) {
    log.info(`sendPurchaseInvite user`, args);
    const agent = getAgent();
    return agent.sendSinglePurchaseInviteUser(args);
  }

  public async createMasqBox(payload: ICreateMasqBoxArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.createMasqBox(payload);
    return content;
  }
}
